import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../../ui';

/**
 * Handler for `/global/auth/logout` — the post-logout redirect target
 * registered on the Cognito app client. Tokens are already cleared by the time
 * the hosted UI redirects here; just return the user to the home route.
 */
export function AuthLogoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center py-24">
      <Spinner label="Signing out" />
    </div>
  );
}

export default AuthLogoutPage;
